module.exports = __webpack_public_path__ + "img/dis-banzu.5f320ff6.svg";